export const getSmartLinksCount = (ssrSmartLinks: { [key: string]: any }) => {
	if (!ssrSmartLinks) {
		return 0;
	}
	let count = 0;
	for (const key in ssrSmartLinks) {
		if (ssrSmartLinks[key].status === 'resolved') {
			count++;
		}
	}
	return count;
};
